import { Controller } from "@hotwired/stimulus"
import { template } from "lodash"

// Dynamiczna lista wierszy nested attributes (umowy/zamówienia/partie towaru) — dodawanie
// z <template>. Wzorzec identyczny jak invoice/additional_descriptions_controller.js.
// Bez sortowania (TODO, spójnie z tamtym kontrolerem).
export default class extends Controller {
  static targets = ["container", "template"]
  static values = { index: { type: Number, default: 0 } }

  rowTemplate

  connect() {
    if (this.hasTemplateTarget) this.rowTemplate = template(this.templateTarget.innerHTML)
  }

  add() {
    if (!this.rowTemplate || !this.hasContainerTarget) return

    this.containerTarget.insertAdjacentHTML("beforeend", this.rowTemplate({ index: this.indexValue }))
    this.indexValue += 1
  }
}
